import util from '../util'

let controller = 'LimiteAprovacaoConta'
export default Object.assign({}, util.GetCrud(controller, null), {
    GetByContaId: function (id) {
        return util.Axios.Get(controller + '/GetByConta', id)
    }
})